import axiosHandler from "interceptor/axiosInterceptor";

export const getAdminUser = async ({ page, pageSize }) => {
  try {
    const response = await axiosHandler.get("/admin-user/view", {
      params: {
        page: page,
        limit: pageSize,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const addAdminUser = async (data) => {
  try {
    const response = await axiosHandler.post("/admin-user/add", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateAdminUser = async (data, adminUserId) => {
  try {
    const response = await axiosHandler.put(
      `/admin-user/edit/${adminUserId}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteAdminUser = async (userId, isActive) => {
  try {
    const response = await axiosHandler.put(
      `/admin-user/delete/${userId}`,
      isActive
    );
    return response;
  } catch (error) {
    throw error;
  }
};
